import React, { Component } from 'react';
import { Button } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import BackupcarStore from 'stores/BackupcarStore'
import BackupCarReservedModal from './BackupCarReservedModal'
import {connect} from 'react-redux'
const NotificationSystem = require('react-notification-system');

class BackupCarReservedButton extends Component {

  constructor(...args) {
    super(...args)
    this.state = this.initState()
  }

  initState(newState) {
    let state = {
      loading:false,
      showEdit:false,
      backupcar_reserved_id:null,
      doc:this.getEmptyDoc(),
      validDoc:this.getEmptyValidDoc(),
      seq:-1,
      bg_select:'#0288d1',
      is_return:false,
    }
    if (newState !== undefined) {
      state = Object.assign(state, newState)
    }
    return state
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
  }

  getEmptyDoc() {
    return {return_status:"0",return_date:null,return_time:null,ref_no:"",remark:"",car_registration_no:"",start_date:"",end_date:"",work_no:"",background:"#0288d1"}
  }

  getEmptyValidDoc() {
    return {return_date_time:null,ref_no:null,car_registration_no:null,start_date:null,end_date:null}
  }

  onOpen() {
    let {doc} = this.state
    let {work_no,car_registration_no} = this.props
    doc.work_no = JSON.parse(JSON.stringify(work_no))
    doc.car_registration_no = JSON.parse(JSON.stringify(car_registration_no))
    this.setState({doc:doc,backupcar_reserved_id:this.props.backupcar_reserved_id},()=>{
      this.setState({showEdit:true})
    })
  }

  onEditHide() {
    let {db_new_click} = this.state
    this.setState({bg_select:'#0288d1',showEdit:false,is_return:false,id:null,ref_no:null,seq:-1,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc()},()=>{
      if (db_new_click) { 
        this.setState({loading:true},()=>{
          this.initTimeline(this.state.data)
          setTimeout(()=>{
            this.setState({loading:false,db_new_click:false})
          },1000)
        })  
      }    
    })
  }

  onJustEditHide() {
    this.setState({showEdit:false})
  }

  onBeforeEditSave(obj,completeFunc=undefined) {
    this.setState({
      validDoc:obj.validDoc,
      doc:obj.doc,
      seq:obj.seq,
      is_return:obj.is_return
    },()=>{
      this.onEditSave(1,()=>{
        if (completeFunc!==undefined)
          completeFunc()
      })
    })
  }

  onEditSave(is_load=1,completeFunc=undefined) {
    let {validDoc,doc,is_return,backupcar_reserved_id} = this.state
    this.setState({loading:true,validDoc:this.getEmptyValidDoc(),isSave:false},()=>{
      if (doc.ref_no==='') {
        validDoc.ref_no = 'error'
        this.setState({validDoc:validDoc,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        return false
      } else if (doc.car_registration_no==='') {
        validDoc.car_registration_no = 'error'
        this.setState({validDoc:validDoc,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        return false
      } else if (doc.start_date==='') {
        validDoc.start_date = 'error'
        this.setState({validDoc:validDoc,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        return false
      } else if (doc.end_date==='') {
        validDoc.end_date = 'error'
        this.setState({validDoc:validDoc,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        return false
      } else if (is_return&&(!doc.return_date||!doc.return_time)) {
        validDoc.return_date_time = 'error'
        this.setState({validDoc:validDoc,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        return false
      }
      let postData = {
        background: doc.background,
        car_registration_no: doc.car_registration_no,
        end_date: doc.end_date,
        ref_no: doc.ref_no,
        remark: doc.remark,
        return_status: "0",
        start_date: doc.start_date,
        work_no: doc.work_no,
        backupcar_reserved_id: backupcar_reserved_id,
        return_date: doc.return_date,
        return_time: doc.return_time,
        return_status: doc.return_status
      }
      this.setState({loading:true},()=>{
        BackupcarStore.saveReservationItems(postData,(result)=>{
          if (result.status==='OK') {
            if (this.props.onSave!==undefined)
              this.props.onSave(result)
            this.setState({loading:false,bg_select:'#0288d1',showEdit:false,is_return:false,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc(),seq:-1})  
          } else {
            if (this.props.onSaveFailed!==undefined)
              this.props.onSaveFailed(result)
            this.setState({loading:false,bg_select:'#0288d1',showEdit:false,is_return:false,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc(),seq:-1})
          }
        })
      })    
    })  
  }

  renderEditModal() {
    let {showEdit,is_return,doc,validDoc,bg_select,seq,backupcar_reserved_id} = this.state
    return(
      <BackupCarReservedModal
        ref='backupCarReservedModal'
        show={showEdit}
        is_return={is_return}
        doc={doc}
        validDoc={validDoc}
        bg_select={bg_select}
        seq={seq}
        brId={backupcar_reserved_id}
        onBeforeEditSave={this.onBeforeEditSave.bind(this)}
        onEditHide={this.onEditHide.bind(this)}
        onJustEditHide={this.onJustEditHide.bind(this)}
        onConfirmDel={()=>{}}
        disabledSelectWork={this.props.disabledSelectWork}
      />
    )
  }

  render() {
    let {title} = this.props
    return(
      <div>
        <Button onClick={this.onOpen.bind(this)} bsStyle='success'>{title}</Button>
        {this.renderEditModal()}
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  } 
}

BackupCarReservedButton.defaultProps = {
  title:(<span><FontAwesome name='plus' /> รายการสำรองรถ</span>),
  work_no:'',
  car_registration_no:'',
  backupcar_reserved_id:null,
  disabledSelectWork:false
}

export default connect(
  (state) => ({messages: state.message.view.backupcar.BackupCarRegistration}),null,null,{withRef:true}
)(BackupCarReservedButton);


// WEBPACK FOOTER //
// ./src/view/backupcar/BackupCarReservedButton.js